import { QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

/**
 * Per-Gemeinde notification behaviour, stored at
 * gemeinden/{gemeindeId}/config/notificationSettings.
 *
 * Holds NO secrets – the SMTP/WhatsApp credentials live centrally in
 * config/notificationCredentials (superadmin only). An *Enabled flag here only
 * takes effect when the matching channel is also released for the Gemeinde
 * (see Gemeinde.channels). A Gemeinde admin may edit these settings.
 */
export default class GemeindeNotificationSettings {
    emailEnabled: boolean;
    whatsappEnabled: boolean;
    pushEnabled: boolean;
    // Fallback preacher used when the assigned preacher has no email / phone.
    representativePreacherKey: string;
    whatsappRepresentativePreacherKey: string;
    // Trial operation: all emails go to the representative only.
    emailOnlyToRepresentative: boolean;
    // The same for WhatsApp: all messages go to the WhatsApp representative only.
    whatsappOnlyToRepresentative: boolean;

    constructor(
        emailEnabled: boolean = false,
        whatsappEnabled: boolean = false,
        pushEnabled: boolean = false,
        representativePreacherKey: string = "",
        whatsappRepresentativePreacherKey: string = "",
        emailOnlyToRepresentative: boolean = false,
        whatsappOnlyToRepresentative: boolean = false
    ) {
        this.emailEnabled = emailEnabled;
        this.whatsappEnabled = whatsappEnabled;
        this.pushEnabled = pushEnabled;
        this.representativePreacherKey = representativePreacherKey;
        this.whatsappRepresentativePreacherKey = whatsappRepresentativePreacherKey;
        this.emailOnlyToRepresentative = emailOnlyToRepresentative;
        this.whatsappOnlyToRepresentative = whatsappOnlyToRepresentative;
    }
}

export const gemeindeNotificationSettingsConverter = {
    toFirestore: (settings: GemeindeNotificationSettings) => {
        return {
            emailEnabled: settings.emailEnabled,
            whatsappEnabled: settings.whatsappEnabled,
            pushEnabled: settings.pushEnabled,
            representativePreacherKey: settings.representativePreacherKey,
            whatsappRepresentativePreacherKey: settings.whatsappRepresentativePreacherKey,
            emailOnlyToRepresentative: settings.emailOnlyToRepresentative,
            whatsappOnlyToRepresentative: settings.whatsappOnlyToRepresentative,
        };
    },

    fromFirestore: (snapshot: QueryDocumentSnapshot, options: SnapshotOptions) => {
        const data = snapshot.data(options);
        return new GemeindeNotificationSettings(
            data.emailEnabled ?? false,
            data.whatsappEnabled ?? false,
            data.pushEnabled ?? false,
            data.representativePreacherKey ?? "",
            data.whatsappRepresentativePreacherKey ?? "",
            data.emailOnlyToRepresentative ?? false,
            data.whatsappOnlyToRepresentative ?? false
        );
    },
};
